// Shopify Product Lazy Loader
document.addEventListener("DOMContentLoaded", function() {
  // Get required elements
  const productGrid = document.getElementById("product-grid");
  const paginationElement = document.querySelector(".pagination");
  let nextPageUrl = null;
  let isLoading = false;
  
  // Check if we're on a product listing page with pagination
  if (!productGrid) return;
  
  // Function to extract the next page URL from pagination
  function getNextPageUrl() {
    const nextLink = document.querySelector('a.pagination__item--next');
    return nextLink ? nextLink.getAttribute('href') : null;
  }
  
  // Hide default pagination if it exists
  if (paginationElement) {
    // paginationElement.style.display = 'none';
    nextPageUrl = getNextPageUrl();
  }
  
  // Function to load more products
  async function loadMoreProducts() {
    console.log(nextPageUrl);
    if (isLoading || !nextPageUrl) return;
    
    isLoading = true;
    
    // Add loading indicator
    const loadingIndicator = document.createElement('div');
    loadingIndicator.className = 'loading-indicator center full-width';
    loadingIndicator.innerHTML = '<span>Loading more products...</span>';
    productGrid.parentNode.appendChild(loadingIndicator);
    
    try {
      // Fetch the next page
      const response = await fetch(nextPageUrl);
      const html = await response.text();
      
      // Create a temporary DOM element to parse the fetched HTML
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      
      // Get the products from the fetched page
      const newProducts = doc.querySelectorAll('#product-grid .grid__item');
      
      // Append new products to the grid
      newProducts.forEach(product => {
        productGrid.appendChild(product);
      });
      
      // Update the next page URL
      const newPagination = doc.querySelector('.pagination');
      if (newPagination) {
        const newNextLink = doc.querySelector('a.pagination__item--next');
        nextPageUrl = newNextLink ? newNextLink.getAttribute('href') : null;
      } else {
        nextPageUrl = null;
      }
      
    } catch (error) {
      console.error('Error loading more products:', error);
    } finally {
      // Remove loading indicator
      if (loadingIndicator) {
        loadingIndicator.remove();
      }
      isLoading = false;
    }
  }
  
  // Set up Intersection Observer for infinite scroll
  const observer = new IntersectionObserver(
    function(entries) {
      entries.forEach(entry => {
        if (entry.isIntersecting && !isLoading) {
          loadMoreProducts();
        }
      });
    },
    {
      rootMargin: "0px 0px 200px 0px", // Start loading before user reaches the bottom
    }
  );
  
  // Create a sentinel element to observe (at the bottom of the product grid)
  const sentinel = document.createElement('div');
  sentinel.className = 'product-grid-sentinel';
  sentinel.style.height = '1px';
  sentinel.style.width = '100%';
  sentinel.style.display = 'flex';
  
  // Append and observe the sentinel
  productGrid.parentNode.appendChild(sentinel);
  observer.observe(sentinel);
});